<template>
  <div class="userList-box">
    <el-form ref="params" :model="params" label-width="auto">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item label="VIP等级" style="margin-bottom: 0">
            <el-select
              placeholder="VIP等级"
              size="small"
              style="width: 100%"
              clearable
              v-model="userParam.vipLevel"
              @change="refreshSearch"
            >
              <el-option
                v-for="item in vipLevelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="有推广码" style="margin-bottom: 0">
            <el-select
              placeholder="是否有推广码"
              size="small"
              style="width: 100%"
              clearable
              v-model="userParam.hasPromotionCode"
              @change="refreshSearch"
            >
              <el-option
                v-for="item in hadPromotList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="上传类型" style="margin-bottom: 0">
            <el-select
              placeholder="是否禁止上传"
              v-model="userParam.forbidUpload"
              clearable
              style="width: 100%"
              size="small"
              @change="refreshSearch"
            >
              <el-option
                v-for="item in isForbid"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="封禁类型" style="margin-bottom: 0">
            <el-select
              placeholder="是否封禁"
              v-model="userParam.hasLocked"
              clearable
              style="width: 100%"
              size="small"
              @change="refreshSearch"
            >
              <el-option
                v-for="item in isLockList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否禁言" style="margin-bottom: 0">
            <el-select
              placeholder="是否禁言"
              v-model="userParam.hasBanned"
              clearable
              style="width: 100%"
              size="small"
              @change="refreshSearch"
            >
              <el-option
                v-for="item in isBannedList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="马甲账号" style="margin-bottom: 0">
            <el-select
              placeholder="是否马甲账号"
              v-model="userParam.isPretendAcc"
              clearable
              style="width: 100%"
              size="small"
              @change="refreshSearch"
            >
              <el-option
                v-for="item in isVestAccount"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="用户ID" style="margin-bottom: 0">
            <el-input
              placeholder="请输入用户id"
              clearable
              v-model="userParam.uid"
              size="small"
              @keyup.enter.native="refreshSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="用户名" style="margin-bottom: 0">
            <el-input
              placeholder="请输入用户名"
              clearable
              v-model="userParam.name"
              size="small"
              @keyup.enter.native="refreshSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="手机号码" style="margin-bottom: 0">
            <el-input
              placeholder="请输入手机号码"
              clearable
              v-model="userParam.mobile"
              size="small"
              @keyup.enter.native="refreshSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="推广码" style="margin-bottom: 0">
            <el-input
              placeholder="请输入推广码"
              clearable
              v-model="userParam.promotionCode"
              size="small"
              @keyup.enter.native="refreshSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="渠道" style="margin-bottom: 0">
            <el-input
              placeholder="请输入渠道"
              clearable
              v-model="userParam.districtCode"
              size="small"
              @keyup.enter.native="refreshSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="注册时间" style="margin-bottom: 0">
            <el-date-picker
              v-model="time"
              type="datetimerange"
              style="width: 100%"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              @change="changeTime"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--操作栏-->
    <div
      class="mt-5 mb-5"
      style="background: #f5f5f5; padding: 5px; border-radius: 5px"
    >
      <el-button type="primary" size="small" @click="refreshSearch"
        >搜索
      </el-button>
      <el-button type="primary" size="small" @click="exportdata"
        >导出
      </el-button>
      <el-button type="primary" size="small" @click="code()"
        >点击查看验证码
      </el-button>
      <el-button type="primary" size="small" @click="openReason('user')"
        >封禁原因配置
      </el-button>
      <el-button type="primary" size="small" @click="openReason('upload')"
        >禁止上传原因配置
      </el-button>
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="auto"
      highlight-current-row
    >
      <el-table-column
        prop="uid"
        label="用户ID"
        align="center"
        width="100"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userImage"
        label="用户头像"
        align="center"
        width="90"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div class="flex flex-c just-center align-item-center ">
            <img-load
                v-if="showImgLoad"
                :width="'30px'"
                :height="'30px'"
                :src="imgUrl + (scope.row.portrait.startsWith('/') ? scope.row.portrait : '/' + scope.row.portrait)"
            ></img-load>
            <span>{{scope.row.name || "未知"}}</span>
            <span  class="red fw" v-if="scope.row.hasLocked">已封禁</span>
          </div>

        </template>
      </el-table-column>
      <el-table-column prop="name" label="相关信息"  width="240">
        <template slot-scope="scope">
          <div>会员身份：<span>{{ scope.row.vipLevelLabel}}</span> / {{ scope.row.vipProductName || "无身份"}}</div>
          <div>VIP到期时间： <span>{{ scope.row.vipExpireDate | changeDate }}</span></div>
          <div>金币限免：<span>{{ scope.row.goldVideoFreeLimit || 0 }}</span></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="注册时间"
        width="240"
      >
        <template slot-scope="scope">
          <div>注册时间：{{ scope.row.createdAt | changeDate }}</div>
          <div>最后活跃时间：{{ scope.row.lastActive | changeDate }}</div>
          <div>登录天数：{{ scope.row.loginDays || 0 }} </div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金币余额"  width="100" align="center"></el-table-column>
      <el-table-column prop="coupons" label="可用观影券"  width="100" align="center"></el-table-column>
      <el-table-column prop="points" label="可用积分"  width="100" align="center"></el-table-column>
      <el-table-column
        prop="districtCode"
        label="渠道"
        align="center"
        fixed
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.districtCode || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="registerIP"
        label="注册IP"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span
            >{{ scope.row.registerIP || "未知" }}</span >
        </template>
      </el-table-column>
      <el-table-column
          prop="sysType"
          label="系统设备-版本"
          align="center"
          width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sysType || "未知" }}-({{ scope.row.ver }})</span>
        </template>
      </el-table-column>

      <el-table-column
          prop="promotionCode"
          label="推广码"
          align="center"
          width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.promotionCode || "未知" }}</span>
        </template>
      </el-table-column>
      <!--TODO -->
      <el-table-column prop="devID" label="UUID" align="left" width="340px">
        <template slot-scope="scope">
          <span class="mr-5">{{ scope.row.devID || "未知" }}</span>
          <el-button
              class="ml-5"
              size="mini"
              type="primary"
              icon="el-icon-refresh"
              @click="refreshDev(scope.row.uid)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="手机号码"
          align="center"
          width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.mobile || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="income"
        label="金币收益"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.income || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="rewarded"
        label="打赏金额"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.rewarded || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="inviterID"
        label="上级ID"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.inviterID || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="inviteCount"
        label="邀请数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.inviteCount || "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="originalSort"
        label="原创博主排序"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.originalSort || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lockReason"
        label="封禁原因"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.lockReason || "未封禁" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lockImg"
        label="封禁图片"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <img-load
            v-if="scope.row.lockImg"
            :width="'80px'"
            :height="'80px'"
            :src="imgUrl + scope.row.lockImg"
          ></img-load>
          <span v-if="!scope.row.lockImg">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isDirect"
        label="是否直推用户"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isDirect ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="superUser"
        label="是否是大V"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.superUser ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="officialCert"
        label="是否官方认证"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.officialCert ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isMadou"
        label="是否工作室"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isMadou ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="taxLevel"
        label="视频扣税率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.taxLevel | taxLevelList }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="region" label="城市" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.region || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoCnt"
        label="视频数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.videoCnt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="undealVideoCnt"
        label="未审核视频数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.undealVideoCnt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="left" fixed="right" width="460">
        <template slot-scope="scope">
          <div class="flex flex-c just-between">
            <div>
              <el-button
                type="success"
                size="mini"
                @click="editUser(scope.row)"
                icon="el-icon-edit"
                >编辑
              </el-button>
              <el-button
                type="success"
                size="mini"
                icon="el-icon-s-platform"
                @click="handleAccountCert(scope.row)"
                >账号凭证
              </el-button>
              <el-button
                type="success"
                size="mini"
                @click="handleComment(scope.row)"
                >留言
              </el-button>
              <el-button
                v-if="scope.row.hasBanned"
                type="info"
                size="mini"
                icon="el-icon-cpu"
                @click="unbanned(scope.row)"
                >解除禁言
              </el-button>
              <el-button
                v-else
                type="warning"
                size="mini"
                icon="el-icon-turn-off-microphone"
                @click="banned(scope.row)"
                >禁言
              </el-button>
              <el-button
                type="success"
                size="mini"
                icon="el-icon-plus"
                @click="handleMovieCert(scope.row)"
                >观影券管理
              </el-button>
            </div>
            <div class="mt-5">
              <el-button
                v-if="!scope.row.hasLocked"
                type="danger"
                size="mini"
                icon="el-icon-turn-off-microphone"
                @click="openSelectReason(scope.row, 'user')"
                >封禁
              </el-button>
              <el-button
                v-else
                type="primary"
                size="mini"
                icon="el-icon-microphone"
                @click="unprohibit(scope.row)"
                >解封
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditCoins(scope.row)"
                >修改金币
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditJifen(scope.row)"
                >修改积分
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-edit"
                @click="handleEditVip(scope.row)"
                >修改身份
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <div style="margin-bottom: 10px">
      <el-pagination
        :page-sizes="[5, 10, 20, 30]"
        :current-page="userParam.pageNumber"
        :page-size="userParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > 1"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </div>

    <!--改积分-->
    <edit-jifen ref="editUserJifen" @goBack="search"></edit-jifen>
    <!--改VIP-->
    <edit-vip ref="editUserVip" @goBack="search"></edit-vip>
    <!--改金币-->
    <edit-coins ref="editUserCoins" @goBack="search"></edit-coins>
    <!--用户编辑弹窗-->
    <edit-user ref="editUser" @goBack="search"></edit-user>
    <!-- 留言 -->
    <add-user-comment ref="userComment" @handleList="search"></add-user-comment>
    <!-- 添加观影券 -->
    <add-movie-cert ref="movieCert" @handleList="search"></add-movie-cert>
    <!-- 点击查看二维码 -->
    <verification-code ref="verificationCode"></verification-code>
    <!--封禁理由弹窗-->
    <reason-action ref="reasonAction" />
    <select-reason ref="selectReason" @handleList="getUserList(userParam)" />
    <!-- 解封操作 -->
    <unblock-page ref="unblockPage" @handleList="getUserList(userParam)" />
    <!-- 回收游戏余额弹窗 -->
    <recycleGameBalance
      ref="recycleBalance"
      @goBack="search"
      @handleList="getUserList(userParam)"
    />
    <!-- 账号凭证 -->
    <el-dialog
      title="用户凭证"
      top="20px"
      :before-close="handleCloseAccountDialog"
      :visible.sync="showAccountDialog"
    >
      <div class="flex">
        <div
          style="display: flex; align-items: center; justify-content: center"
          class="flex1"
        >
          <qr-code :value="qrcodeData" :width="240" />
        </div>
        <div
          class="flex1"
          style="
            height: 200px;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
          "
        >
          <div class="fz24 fw">
            用户动态口令是：{{ pwd.toLowerCase() || "暂无" }}
          </div>
          <div class="mt-8">
            <el-button
              type="primary"
              icon="el-icon-s-promotion"
              @click="handleCreatePwd(uid)"
              >生成动态口令</el-button
            >
            <el-button
              v-if="pwd"
              type="warning"
              icon="el-icon-s-promotion"
              @click="copyId(pwd.toLowerCase())"
              >复制口令给用户</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import {changeTime, paramsFilter, sortEscape} from "@/utils/global";
import EditUser from "./components/edit-user";
import EditVip from "./components/edit-vip";
import EditJifen from "./components/edit-jifen";
import EditCoins from "./components/edit-coins";
import ReasonAction from "@/components/reasonAction";
import SelectReason from "@/components/selectReasonAction";
import UnblockPage from "./components/unblockPage";
import RecycleGameBalance from "./components/recycleGameBalance";
import AddUserComment from "./components/addUserComment.vue";
import AddMovieCert from "./components/addMovieCert.vue";
import QrCode from "@/components/qrCode.vue";
import API from "@/api";
import VerificationCode from "./components/verification-code";
import {validatorMobile} from "@/utils/validator";

export default {
  data() {
    return {
      dialogFormVisible: false,
      banTableData: [],
      showImgLoad: true,
      uid: "",
      pwd: "",
      auth: true,
      showAccountDialog: false,
      banTotal: "",
      banLoading: false,
      form: {
        phone: "",
      },
      imgUrl: baseConfig.imgUrl,
      roleList: [
        { value: "snap", label: "普通用户" },
        { value: "user", label: "VIP用户" },
      ],
      vipLevelList: [
        { value: 0, label: "普通用户" },
        { value: 1, label: "VIP" },
        { value: 2, label: "超级VIP" },
      ],
      hadPromotList: [
        { value: true, label: "有" },
        { value: false, label: "无" },
      ],
      rules: {
        phone: [
          {
            required: true,
            message: "请输入正确格式的手机号码",
            trigger: "blur",
          },
          { validator: validatorMobile, trigger: "blur" },
        ],
      },
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      qrcodeData: "",
      idList: [],
      // 封禁理由列表参数
      params: {
        pageNumber: 1,
        pageSize: 20,
      },
      // 用户管理列表请求参数
      userParam: {
        uid: "",
        pageNumber: 1,
        pageSize: 20,
        key: "",
        hasBanned: "",
        isPretendAcc: "",
        value: "",
        role: null,
        vipLevel: null,
        hasPromotionCode: null,
        name: null,
        mobile: null,
        promotionCode: null,
        districtCode: null,
        forbidUpload: null,
        startTime: "",
        endTime: "",
        captcha: "",
      },
      isForbid: [
        { label: "已禁止", value: true },
        { label: "未禁止", value: false },
      ],
      isLockList: [
        { label: "已封禁", value: true },
        { label: "未封禁", value: false },
      ],
      isBannedList: [
        { label: "已禁言", value: true },
        { label: "未禁言", value: false },
      ],
      isVestAccount: [
        { label: "马甲账号", value: 1 },
        { label: "所有账号", value: 2 },
      ],
    };
  },
  components: {
    EditUser,
    EditVip,
    EditJifen,
    EditCoins,
    VerificationCode,
    SelectReason,
    ReasonAction,
    UnblockPage,
    AddUserComment,
    RecycleGameBalance,
    AddMovieCert,
    QrCode,
  },
  created() {
    this.auth = true;
    this.refreshSearch();
  },
  methods: {
    handleEditCoins(row) {
      let querParams = {
        uid: row.uid,
        amount: row.amount,
      };
      this.$refs.editUserCoins.open(querParams);
      // const params = {
      //   uid: row.uid,
      // };
      // API.getUserGold(params)
      //   .then((res) => {
      //     if (res.code === 200) {
      //       console.log10(res, 'res')
      //     } else {
      //       this.$message.error("操作失败!");
      //     }
      //   })
      //   .catch(() => {});
      // //
    },

    handleEditVip(row) {
      this.$refs.editUserVip.open(row);
    },

    handleEditJifen(row) {
      this.$refs.editUserJifen.open(row);
    },

    async handleCreatePwd(uid) {
      const res = await API.Createpwd({ uid });
      if (res.msg == "success") {
        this.pwd = res.data || "";
      }
    },
    copyId(id) {
      // 创建一个临时的 textarea 元素
      const textarea = document.createElement("textarea");
      textarea.value = id;
      document.body.appendChild(textarea);
      // 选中文本
      textarea.select();
      // 执行复制命令
      document.execCommand("copy");
      // 移除临时元素
      document.body.removeChild(textarea);
      // 显示成功提示
      this.$message({
        message: `用户您好你的动态口令是（不区分大小写）：${id} `,
        type: "success",
      });
    },
    handleComment(val) {
      const formateData = {
        uid: val.uid,
      };
      this.$refs.userComment.open(formateData);
    },
    handleMovieCert(val) {
      const formateData = {
        uid: val.uid,
      };
      this.$refs.movieCert.open(formateData);
    },
    handleAccountCert(val) {
      this.qrcodeData = val.qrCode;
      this.pwd = val.pwd || "";
      this.uid = val.uid;
      setTimeout(() => {
        this.showAccountDialog = true;
      }, 100);
    },
    handleCloseAccountDialog() {
      this.showAccountDialog = false;
    },
    udpateForbid(row, type) {
      const params = Object.assign(
        {},
        {
          uidList: [row.uid],
          enable: type,
        }
      );
      API.resetForbid(params)
        .then((res) => {
          res.code === 200 &&
            (this.$message.success("修改用户禁止上传文件状态成功！"),
            this.getUserList(this.userParam));
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        });
    },
    // 查看二维码
    code() {
      this.$refs.verificationCode.open();
    },
    // 封禁原因配置
    openReason(type) {
      this.$refs.reasonAction.open(type);
    },
    // 根据手机号查看或生成验证码
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getViewCaptcha();
        } else {
          return false;
        }
      });
    },
    getViewCaptcha() {
      this.loading = true;
      API.getViewCaptcha(this.phone)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dialogFormVisible = false;
            let captcha = res.data.captcha;
            return captcha;
          }
        })
        .then((captcha) => {
          this.$message({
            type: "success",
            message: "你的验证码是: " + captcha,
          });
        });
      this.getUserList(this.userParam);
    },
    // 更新设备
    refreshDev(uid) {
      this.$confirm("您确定要更新当前用户的设备id？", "更新提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "cancel_right",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: uid,
          };
          API.resetDev(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "用户设备id更新成功",
                type: "success",
              });
              this.refreshSearch();
            }
          });
        })
        .catch(() => {});
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.userParam.startTime = changeTime(time[0]);
        this.userParam.endTime = changeTime(time[1]);
      } else {
        this.userParam.startTime = "";
        this.userParam.endTime = "";
      }
      this.refreshSearch();
    },
    // 搜索对应列表
    refreshSearch() {
      this.userParam.pageNumber = 1;
      this.getUserList(this.userParam);
    },
    // 导出数据
    exportdata() {
      let params = paramsFilter(this.userParam);
      let str = "";
      for (let key in params) {
        if (key == "startTime" || key == "endTime") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);
      let url = baseConfig.baseServerUrl + "/export/userList?" + str;
      window.location.href = url;
    },
    // 搜索对应列表
    search() {
      this.getUserList(this.userParam);
    },
    // 请求用户列表
    getUserList(obj) {
      this.loading = true;
      this.showImgLoad = false
      API.getUserList(obj)
        .then((res) => {
          this.showImgLoad = true
          if (res.code === 200 && res.data.list) {
            let  vipObj = {
                0: "普通用户",
                1: "VIP",
                2: "SVIP",
              };
            this.tableData = res.data.list;
            this.tableData.forEach((item) => {
              item.vipLevelLabel = vipObj[item.vipLevel]
                ? vipObj[item.vipLevel]
                : "-";
            });
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;

          this.$nextTick(()=>{
            var tbodyDoms = document.getElementsByTagName("tbody")[0]
            var trDoms = tbodyDoms.children
            for (let i = 0; i < trDoms.length; i++) {
              trDoms[i].addEventListener("click", function (e) {
                for (let j = 0; j < trDoms.length; j++) {
                  if (trDoms[j] != this) {
                    trDoms[j].removeAttribute("style")
                  }
                }
                if (this.style.backgroundColor) {
                  this.style.backgroundColor = ""
                } else {
                  this.style.backgroundColor = "rgba(245, 108, 108,0.2)"
                }
                e.stopPropagation()
              })
            }
          })
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.userParam.value = sortEscape(column.order);
      this.userParam.key = column.prop;
      this.getUserList(this.userParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.userParam.pageSize = size;
      this.userParam.pageNumber = 1;
      this.getUserList(this.userParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.userParam.pageNumber = pageNumber;
      this.getUserList(this.userParam);
    },
    // 编辑用户
    editUser(row) {
      this.$refs.editUser.open(row);
    },
    // 请求禁言或解禁用户
    banUser(params) {
      API.getUserBan(params).then((res) => {
        if (res.code === 200) {
          if (params.enable) {
            this.$message({
              message: "禁言用户成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "解除禁言成功",
              type: "success",
            });
          }
          this.search();
        }
      });
    },
    // 禁言用户
    banned(row) {
      this.$confirm("您确定要禁言当前用户？", "禁言提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uidList: [row.uid],
            enable: true,
          };
          this.banUser(params);
        })
        .catch(() => {});
    },
    // 解除禁言用户
    unbanned(row) {
      this.$confirm("您确定要解除当前用户禁言？", "解除禁言提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uidList: [row.uid],
            enable: false,
          };
          this.banUser(params);
        })
        .catch(() => {});
    },
    // 点击封禁按钮打开弹窗
    openSelectReason(row, type) {
      this.$refs.selectReason.open(row, type);
    },
    // 点击解禁按钮打开弹窗
    unprohibit(row) {
      this.$refs.unblockPage.open(row);
    },
    // 回收游戏余额
    recycleBalance(row) {
      this.$refs.recycleBalance.open(row);
    },
    // 查看视频观看列表
    checkedVideo(row) {
      this.$refs.viewVideo.open(row);
    },
  },
};
</script>
<style lang="scss">
.el-message-box {
  .cancel_right {
    float: right;
    margin-left: 10px;
  }
}
</style>
<style scoped lang="scss">
.action-bar {
}

.userList-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .v-number {
    vertical-align: middle;
  }

  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;

    &:hover {
      color: #eb5f84;
    }
  }

  ::v-deep  .el-button + .el-button {
    margin-left: 5px !important;
  }

  ::v-deep  .col_layout {
    ::v-deep  div {
      display: flex;
      justify-content: center;
      padding-left: 50px;

      button {
        margin-left: auto;
      }
    }
  }
}
</style>
